import { Formik } from "formik";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { Spinner, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as Yup from 'yup' 
import React from "react";

import { showErrorToast, login, setUserData } from "../../../../redux";
import API from "../../../../common/api";
import Input from "../../../General/Form/Input";
import PasswordInput from "../../../General/Form/PasswordInput";

const validationSchema = Yup.object({
  password: Yup.string()
    .nullable()
    .required('The password field is required.'),
  username: Yup.string()
    .nullable()
    .required('The Email/Username field is required.')
})

function LoginSection() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation()
  const redirectTo = new URLSearchParams(location.search).get('to')
  
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
 
  return (
    <div className="content" style={{ minHeight: "250px", padding: "1rem 0" }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="account-content">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-7 col-lg-6 login-left">
                  <img
                    src={process.env.PUBLIC_URL+"/assets/img/login-banner.png"}
                    className="img-fluid"
                    alt="Doccure Login"
                  />
                </div>
                <div className="col-md-12 col-lg-6 login-right">
                  <div className="login-header">
                    <h3>
                      Login <span>emedicare</span>
                    </h3>
                  </div>
                  <Formik
                    initialValues={{
                      username: "",
                      password: "",
                    }}

                    validationSchema={validationSchema}

                    onSubmit={(
                      { username, password },
                      { setErrors, setSubmitting }
                    ) => {
                      setSubmitting(true);

                      API.login({ username, password })
                        .then((res) => {
                          const { data } = res;
                          const isPatient = data.user_type === "PATIENT"
                           if (data.user_type === "PATIENT") {
                            dispatch(login(data));
                            history.push(redirectTo && isPatient ? redirectTo : "/");
                           }
                           else if (data.user_type === "DOCTOR") {
                            dispatch(login(data));
                            history.push("/dashboard");
                           } else {
                            dispatch(showErrorToast("Not an authorized user"));
                            setSubmitting(false);
                           }
                        }).catch(error => {
                          console.log(error.response)
                          const {
                            response: {
                              data: {
                                message, errors = {}
                              } = {}
                            } = {},
                          } = error;

                          if(errors.email_otp && errors.mobile_otp){
                            Promise.all([
                              API.resendEmailOtp(errors.email[0]),
                              API.resendMobileOtp(errors.mobile_number[0])
                            ]).then(response => {
                              history.push({
                                pathname: '/signup/confirm',
                                search: '?type=first-time',
                                state: {
                                  email: errors.email,
                                  mobile_number: errors.mobile_number
                                }
                              });
                            })
                            .catch(error => {
                              dispatch(showErrorToast("Error occurred while sending verification codes"));
                            });
                          }else{
                            let errorMessages = [...Object.values(errors)];
                            if (errorMessages && errorMessages.length > 0) {
                              setErrors(errors);
                            }
                            dispatch(showErrorToast([message]));
                            setSubmitting(false);
                          }
                        });
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      isValid,
                      dirty
                    }) => (<>
                      <form onSubmit={handleSubmit}>
                        <Input
                          value={values.username}
                          name="username"
                          label="Email/Username"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          hasError={touched.username && errors.username}
                          feedback={errors.username}
                        />
                        <PasswordInput
                          value={values.password}
                          name="password"
                          noHint
                          onChange={handleChange}
                          onBlur={handleBlur}
                          hasError={touched.password && errors.password}
                          feedback={errors.password}
                        />
                        <div className="text-right">
                          <NavLink
                            className="forgot-link"
                            to="/forgot-password"
                          >
                            Forgot Password ?
                          </NavLink>
                        </div>
                        <Button
                          disabled={!dirty || !isValid || isSubmitting}
                          variant="primary"
                          size="lg"
                          style={{ height: "52px" }}
                          block
                          type="submit"
                        >
                          {isSubmitting ? (
                            <Spinner animation="border" />
                          ) : (
                              "Login"
                            )}
                        </Button>

                      </form>
                      <div className="login-or">
                        <span className="or-line"></span>
                        <span className="span-or">or</span>
                      </div> 
                      <div className="text-center dont-have">
                        Don’t have an account?{" "}
                        <NavLink className="btn-link" to="/signup">
                          Register
                          </NavLink>
                      </div>
                    </>
                      )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LoginSection;
